/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {Link, Switch, Redirect, useHistory} from "react-router-dom";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import {ContentRoute} from "../../../../_metronic/layout"
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/login-3.scss";
import {Formik} from "formik";
import {useDispatch, useSelector} from "react-redux";
import * as Yup from 'yup';
import axios from 'axios';
import {UPDATE_USER_PASSWORD} from "../../../api/Api";
import {actions as authActions} from "../_redux/authRedux";


const ValidationSchema = Yup.object().shape({
    password: Yup.string()
        .required('Vous devez saisir le mot de passe')
        .min(8,'Votre mot de passe doit contenir au moins 8 caractères')
        .matches(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&"'()§^:;,])[A-Za-z\d@$!%*#?&"'()§^:;,]{8,}$/,
            "Le mot de passe doit contenir au moins 8 caractères, et au moins une majuscule, une minuscule , un chiffre et un symbole"
        ),
    passwordConfirmation: Yup.string()
        .required('Vous devez confirmater le mot de passe')
    .oneOf([Yup.ref('password'), null], 'Les mots de passes doivent être identiques')

});


export function FirstPasswordUpdate() {

    const {user} = useSelector(state => state.auth);
    const dispatcher = useDispatch()

    const history = useHistory();


    const [isUpdatingPassword,setIsUpdatingPassword] = React.useState(false)

    async function updatePassword(values,helpers){

        try {

            const response = (await axios.patch(
                UPDATE_USER_PASSWORD,
                {
                    ...values
                }
            ));

            if (response.status === 200) {
                dispatcher(authActions.fulfillUser(response.data))
            } else {
                console.log('Some error happened when updating')
                //Display some error toast
            }


        } catch (e) {
            console.log(e);
        } finally {
            helpers.setSubmitting(false);
        }


    }

    return (
        <>
            <div className="d-flex flex-column flex-root">
                {/*begin::Login*/}
                <div
                    className="login login-3 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
                    id="kt_login"
                >

                    {/*begin::Content*/}
                    <div className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden">
                        {/*begin::Content header*/}
                        {/*<div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">*/}
                        {/*  <span className="font-weight-bold text-dark-50">Don't have an account yet?</span>*/}
                        {/*  <Link to="/auth/registration" className="font-weight-bold ml-2" id="kt_login_signup">Sign Up!</Link>*/}
                        {/*</div>*/}
                        {/*end::Content header*/}

                        {/* begin::Content body */}
                        <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">

                            <Formik
                                onSubmit={updatePassword}
                                validationSchema={
                                    ValidationSchema
                                }
                                initialValues={{
                                    currentPassword: '',
                                    password: '',
                                    passwordConfirmation: ''
                                }}
                            >
                                {
                                    (formikHelpers) => {
                                        console.log(formikHelpers)
                                        return (

                                            <div>

                                                <div className={'h1 text-muted font-weight-lighter'}>
                                                    Bienvenue <span className={'text-primary font-weight-bold'}>{user.nom} {user.prenoms}</span>
                                                </div>
                                                
                                                <div className={'small font-weight-bold my-5'}>
                                                    <div>
                                                        Vous devez changer votre mot de passe afin de pouvoir utiliser l'application
                                                    </div>
                                                </div>

                                                {/*<div className="form-group fv-plugins-icon-container" style={{width: 390}}>*/}

                                                {/*    <label className="font-size-h6 font-weight-bolder text-primary">Mot de passe actuel</label>*/}
                                                {/*    <input*/}
                                                {/*        placeholder="Mot de passe"*/}
                                                {/*        type="password"*/}
                                                {/*        onChange={(event)=>formikHelpers.setFieldValue('currentPassword',event.target.value)}*/}
                                                {/*        className={`form-control form-control-solid h-auto py-7 px-6`}*/}
                                                {/*        name="password"*/}
                                                {/*    />*/}
                                                {/*    {formikHelpers.touched.currentPassword && formikHelpers.errors.currentPassword ? (*/}
                                                {/*        <div className="fv-plugins-message-container">*/}
                                                {/*            <div className="fv-help-block">{formikHelpers.errors.currentPassword}</div>*/}
                                                {/*        </div>*/}
                                                {/*    ) : null}*/}
                                                {/*</div>*/}

                                                <div className="form-group fv-plugins-icon-container" style={{width: 390}}>

                                                    <label className="font-size-h6 font-weight-bolder text-primary">Nouveau mot de passe</label>
                                                    <input
                                                        placeholder="Mot de passe"
                                                        type="password"
                                                        value={formikHelpers.values.password}
                                                        onChange={(event)=>formikHelpers.setFieldValue('password',event.target.value)}
                                                        className={`form-control form-control-solid h-auto py-7 px-6`}
                                                        name="password"
                                                    />
                                                    {formikHelpers.touched.password && formikHelpers.errors.password ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formikHelpers.errors.password}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <label className="font-size-h6 font-weight-bolder text-primary">Confirmation du nouveau mot de passe</label>

                                                    <input
                                                        placeholder="Confirmation du mot de passe"
                                                        type="password"
                                                        value={formikHelpers.values.passwordConfirmation}
                                                        onChange={(event)=>formikHelpers.setFieldValue('passwordConfirmation',event.target.value)}
                                                        className={`form-control form-control-solid h-auto py-7 px-6`}
                                                        name="password"
                                                    />
                                                    {formikHelpers.touched.passwordConfirmation && formikHelpers.errors.passwordConfirmation ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formikHelpers.errors.passwordConfirmation}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
                                                    {/*<Link*/}
                                                    {/*  to="/auth/forgot-password"*/}
                                                    {/*  className="text-dark-50 text-hover-primary my-3 mr-2"*/}
                                                    {/*  id="kt_login_forgot"*/}
                                                    {/*>*/}
                                                    {/*  <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />*/}
                                                    {/*</Link>*/}
                                                    <button
                                                        id="kt_login_signin_submit"
                                                        type="submit"
                                                        onClick={()=>formikHelpers.submitForm()}
                                                        disabled={formikHelpers.isSubmitting}
                                                        className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
                                                    >
                                                        <span>Je change le mot de passe</span>
                                                        {formikHelpers.isSubmitting && <span className="ml-3 spinner spinner-white"></span>}
                                                    </button>

                                                    <button
                                                        id="kt_login_signin_submit"
                                                        type="submit"
                                                        onClick={()=>{
                                                            history.push("/logout");
                                                        }}
                                                        className={`btn btn-light-primary small font-weight-bold px-9 py-4 my-3`}
                                                    >
                                                        <span>Deconnexion</span>
                                                    </button>
                                                </div>

                                            </div>

                                        )
                                    }
                                }
                            </Formik>

                        </div>
                        {/*end::Content body*/}

                        {/* begin::Mobile footer */}
                        <div
                            className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
                            <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                                &copy; 2020 Metronic
                            </div>
                            <div className="d-flex order-1 order-sm-2 my-2">
                                <Link to="/terms" className="text-dark-75 text-hover-primary">
                                    Privacy
                                </Link>
                                <Link
                                    to="/terms"
                                    className="text-dark-75 text-hover-primary ml-4"
                                >
                                    Legal
                                </Link>
                                <Link
                                    to="/terms"
                                    className="text-dark-75 text-hover-primary ml-4"
                                >
                                    Contact
                                </Link>
                            </div>
                        </div>
                        {/* end::Mobile footer */}
                    </div>
                    {/*end::Content*/}
                </div>
                {/*end::Login*/}
            </div>
        </>
    );
}
